import {
  Datagrid,
  Filter,
  List,
  SearchInput,
  TextField,
  useRefresh,
  useTranslate,
  useRecordContext,
} from 'react-admin'
import UpsertFileButton, { PreviewButton } from '../components/file_upload'
import FileWithContext from '../models/file_with_context'

const CoownershipRulesListFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="copro_code" />
  </Filter>
)

const UpsertFileWrapper = () => {
  const record = useRecordContext()
  const refresh = useRefresh()
  if (!record) return null
  let defaultValue = []
  if (record.url) defaultValue = [record]

  return (
    <UpsertFileButton
      resource="file_with_context"
      documentType={FileWithContext.DOCUMENT_TYPE.COPRO}
      issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
      previewAttachedFiles={false}
      validTypes={[FileWithContext.TYPE.COOWNERSHIP_RULES]}
      validCategories={[FileWithContext.CATEGORY.BUILDING]}
      linkable_type={record.linkable_type}
      linkable_id={record.linkable_id}
      defaultValue={defaultValue}
      copro_id={record.linkable_id}
      saveResult={(result) => {
        if (result.accepted_files.length > 0) refresh()
      }}
    />
  )
}

export const CoownershipRulesList = (props) => {
  const translate = useTranslate()

  return (
    <List
      {...props}
      exporter={false}
      hasCreate={false}
      perPage={100}
      filters={<CoownershipRulesListFilter />}
    >
      <Datagrid bulkActionButtons={false}>
        <TextField source="copro_code" />
        <TextField source="purpose" />
        <PreviewButton
          label={translate(
            'resources.compliance/coownership_rules.fields.preview_document'
          )}
          source="url"
        />
        <UpsertFileWrapper />
      </Datagrid>
    </List>
  )
}
